export const locale = {
    lang: 'tr',
    data: {
        'HOME': {
            'HELLO': 'Merhaba Dünya!'
        }
    }
};
